module.exports = __webpack_public_path__ + "img/bg_hb1@2x.548173c8.png";